import { signal } from '@angular/core';
import { TCatalogOption } from '../model';

export const debitDayCatalog$$ = signal<TCatalogOption[]>([
  { key: '2 בחודש', value: 2 },
  { key: '10 בחודש', value: 10 }
]);
